<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation>
      <v-container fluid>
          <v-layout row>
              <v-flex xs2>
                  <v-subheader>ID</v-subheader>
              </v-flex>
              <v-flex xs10 mt-3>
                  {{assembly.id}}
              </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs2>
                  <v-subheader>Type</v-subheader>
              </v-flex>
              <v-flex xs10 mt-3>
                  {{getAssemblyTypeNameById(assembly.type)}}
              </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs2>
                  <v-subheader>Boardnummer</v-subheader>
              </v-flex>
              <v-flex xs10>
                  <v-text-field v-model="assembly.boardSerialnumber"
                                :counter="10"></v-text-field>
              </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs2>
                  <v-subheader>Behuizingnummer</v-subheader>
              </v-flex>
              <v-flex xs10>
                  <v-text-field v-model="assembly.caseSerialnumber"
                                :counter="10"></v-text-field>
              </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs2>
                  <v-subheader>Bluetooth</v-subheader>
              </v-flex>
              <v-flex xs10 mt-3>
                  {{assembly.bluetoothId}}
              </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs2>
                  <v-subheader>Status</v-subheader>
              </v-flex>
              <v-flex xs10>
                  <v-select :items="states"
                            item-value="key"
                            item-text="value"
                            v-model="assembly.state">
                  </v-select>
              </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs2>
                  <v-subheader>Uitgeleverd</v-subheader>
              </v-flex>
              <v-flex xs10>
                  <v-dialog ref="dialog1"
                            v-model="modal"
                            :return-value.sync="assembly.shippedOut"
                            persistent
                            lazy
                            full-width
                            width="290px">
                      <v-text-field slot="activator"
                                    v-model="getShippedDate"></v-text-field>
                      <v-date-picker locale="nl-nl"
                                     no-title
                                     v-model="assembly.shippedOut"
                                     @input="$refs.dialog1.save(assembly.shippedOut)"
                                     scrollable>
                      </v-date-picker>
                  </v-dialog>
              </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs2>
                  <v-subheader>Ordernummer</v-subheader>
              </v-flex>
              <v-flex xs10>
                  <v-text-field v-model="assembly.orderNumber"
                                :counter="100"></v-text-field>
              </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs2>
                  <v-subheader>Klant</v-subheader>
              </v-flex>
              <v-flex x10>
                  <v-text-field v-model="assembly.client"
                                :counter="100"></v-text-field>
              </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs2>&nbsp;</v-flex>
              <v-flex xs10>
                  <v-btn color="success" @click="submit">save</v-btn>
                  <v-btn color="error" @click="deleteAssembly">delete</v-btn>
                  <v-btn color="primary" @click="back">close</v-btn>
              </v-flex>
          </v-layout>
      </v-container>
  </v-form>
</template>

<script>
  export default {
    props: ['assembly'],
    data: () => ({
      submitStatus: null,
      valid: false,
      modal: false,
      stringRules: [
        v => !!v || 'This field is required',
        v => (v && v.length <= 100) || '100 characters maximum'
      ],
      states: [
        { key: 0, value: 'Nieuw' },
        { key: 1, value: 'Geassembleerd' },
        { key: 2, value: 'Getest' },
        { key: 3, value: 'Uitgeleverd' },
        { key: 4, value: 'RMA' },
        { key: 5, value: 'Vernietigd' },
      ],
      assemblyTypes: []
    }),
    computed: {
      getShippedDate () {
        return this.$moment(this.assembly.shippedOut).format('dddd D MMMM')
      } 
    },
    methods: {
      deleteAssembly() {
          this.submitStatus = 'Deleting..'
          this.$http.delete('api/assembly/' + this.assembly.id)
            .then(request => {
              //console.log(request) /* eslint-disable-line no-console */
              if (request.status == 200) {
                this.assembly.id = request.data
                this.submitStatus = 'OK'
                this.$emit('done')
              } else {
                this.submitStatus = 'ERROR'
              }
            })
            .catch(() => { 
              console.log('delete error!') /* eslint-disable-line no-console */
              this.submitStatus = 'ERROR'
            })
      },
      submit() {
        if (!this.$refs.form.validate()) {
          this.submitStatus = 'ERROR'
        } else {
          this.submitStatus = 'Saving..'
          delete this.assembly.bluetoothId
          this.$http.put('api/assembly/' + this.assembly.id, this.assembly)
            .then(request => {
              //console.log(request) /* eslint-disable-line no-console */
              if (request.status == 201) {
                this.assembly.id = request.data
                this.submitStatus = 'OK'
                this.$emit('done')
              } else {
                this.submitStatus = 'ERROR'
              }
            })
            .catch(() => { 
              console.log('put error!') /* eslint-disable-line no-console */
              this.submitStatus = 'ERROR'
            })
        }
      },
      back () {
        this.$emit('done')
      },
      getAssemblyTypes() {
        this.$http
          .get("api/assembly/types")
          .then(request => {
            this.assemblyTypes = request.data;
          })
          .catch(e => {
              console.log('get error!', e) /* eslint-disable-line no-console */
              this.submitStatus = 'ERROR'
          });
      },
      getAssemblyTypeNameById(id) {
        if (this.assemblyTypes.length) {
          return this.assemblyTypes.find(x => x.id == id).name;
        }
        return '';
      }
    },
    mounted() {
      this.getAssemblyTypes();
    }
  }
</script>